// 44px 작업 큐 행 (시안 .q) — 처리 필요 목록. 색점 + [태그] 제목/부제 + 경과 필 + 액션 링크 (+ 닫기).
// props: tone:'warn'|'info'|'danger'|'gray', tag(문자열 또는 노드 — 제목 앞 작은 필), title, sub,
//        age:{label, danger}, action:{label, onClick}, onClick (행), onDismiss, isMobile(생략 시 useIsMobile)
// 모바일에서는 액션·닫기 버튼이 최소 40×40 (BRIEF §1.6 터치 40px).
import React from 'react';
import { useIsMobile } from '../../utils/useMobile';
import { T, FONT, NUM } from '../theme';

var DOT = { warn: T.dotWarn, info: T.dotInfo, danger: T.red, gray: T.faint };
var row = { display: 'flex', alignItems: 'center', gap: 10, minHeight: 44, padding: '6px 14px', borderBottom: '1px solid ' + T.bdSoft };
var ttl = { fontSize: FONT.body, color: T.ink, fontWeight: 700, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' };
var subSt = { display: 'block', fontSize: FONT.label, color: T.faint, marginTop: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' };
// 선행 태그 — 문자열이면 중립 필로 감싼다(노드면 호출자 것을 그대로: Pill/StatusPill 등).
var tagSt = { display: 'inline-block', fontSize: FONT.badge, fontWeight: 800, borderRadius: 5, padding: '1px 6px', marginRight: 6,
  color: T.muted, background: T.head, border: '1px solid ' + T.bd, verticalAlign: 'middle', whiteSpace: 'nowrap' };
var ageBase = Object.assign({ fontSize: FONT.badge, fontWeight: 800, borderRadius: 5, padding: '1px 6px', whiteSpace: 'nowrap', flexShrink: 0 }, NUM);
var ageWarn = Object.assign({}, ageBase, { color: T.warn, background: T.warnTint, border: '1px solid ' + T.warnBd });
var ageDanger = Object.assign({}, ageBase, { color: T.danger, background: T.dangerTint, border: '1px solid ' + T.dangerBd });
var act = { fontSize: 11.5, fontWeight: 700, color: T.accentPress, background: 'none', border: 'none', padding: '4px 2px', cursor: 'pointer', fontFamily: 'inherit', whiteSpace: 'nowrap', flexShrink: 0 };
var dismiss = { border: 'none', background: 'none', color: T.faint, fontSize: 13, cursor: 'pointer', padding: '4px 4px', flexShrink: 0 };
var actMob = Object.assign({}, act, { minWidth: 40, minHeight: 40, padding: '4px 8px' });
var dismissMob = Object.assign({}, dismiss, { minWidth: 40, minHeight: 40, fontSize: 15 });

function QueueRow(props) {
  var auto = useIsMobile();
  var isMobile = props.isMobile == null ? auto : !!props.isMobile;
  var stop = function (fn) { return function (e) { e.stopPropagation(); if (fn) fn(e); }; };
  var tag = (props.tag == null || props.tag === '') ? null
    : (typeof props.tag === 'string' || typeof props.tag === 'number' ? <span style={tagSt}>{props.tag}</span> : props.tag);
  return (<div className="v2-qrow" role={props.onClick ? 'button' : undefined} onClick={props.onClick}
    style={Object.assign({}, row, props.onClick ? { cursor: 'pointer' } : null)}>
    <i style={{ width: 8, height: 8, borderRadius: 999, background: DOT[props.tone] || T.faint, flex: 'none' }} />
    <div style={{ flex: 1, minWidth: 0 }}>
      <div style={ttl}>{tag}{props.title}</div>
      {props.sub ? <span style={subSt}>{props.sub}</span> : null}
    </div>
    {props.age && props.age.label ? <span style={props.age.danger ? ageDanger : ageWarn}>{props.age.label}</span> : null}
    {props.action ? <button type="button" style={isMobile ? actMob : act} onClick={stop(props.action.onClick)}>{props.action.label}</button> : null}
    {props.onDismiss ? <button type="button" aria-label="닫기" title="닫기" style={isMobile ? dismissMob : dismiss} onClick={stop(props.onDismiss)}>✕</button> : null}
  </div>);
}

export default QueueRow;
